import PosthogService from '~/services/posthog/PosthogService';

export interface IRequestSubmittedPayload {
  shiftsPosted: number;
  autoconfirmFavorite: 'on' | 'off';
  autoconfirmEligible: 'on' | 'off';
  totalInvitesSent: number;
}

/**
 * Fires when the user clicks the active "Post X Shifts" button on the
 * "Review & Confirm" step of the NEW Shift Request flow
 * Event: dental_portal:shift_request:request_submitted
 */
export function fireRequestSubmitted(payload: IRequestSubmittedPayload): void {
  PosthogService.getInstance().track('dental_portal:shift_request:request_submitted', {
    shifts_posted: payload.shiftsPosted,
    'Design Date': 202603,
    autoconfirm_favorite: payload.autoconfirmFavorite,
    autoconfirm_eligible: payload.autoconfirmEligible,
    total_invites_sent: payload.totalInvitesSent,
  });
}
